import { Col, Row, Spin } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Alerta } from '../../../../constants';
import { administradoresAlertaNivelSelector } from '../../../../store/empresa';
import { useSelector } from 'react-redux';
import { useHistory, useRouteMatch } from 'react-router';
import ActionBar from '../../../../components/action-bar';
import ActionButton from '../../../../components/action-button';
import TextAnexo from '../../../../components/text-anexo';
import TextItem from '../../../../components/text-item';
import { EmpresaAdministrador, findByIdAndMap } from '../../../../constants';
import useFormatter from '../../../../hooks/useFormatter';
import useLoading from '../../../../hooks/useLoading';
import { administradoreSelector, fetchAdministrador, isEditableSelector } from '../../../../store/empresa';
import { openPopup } from '../../../../util/window';
import useModulo from '../../../../hooks/useModulo';
import { useLocation } from "react-router";
import { useState } from "react";
import TarefasDrawer from '../../licencas/_tarefasDrawer';
import { formatCpf } from '../../../../util/cpf';

const { Tipo, Remuneracao, Representacao } = EmpresaAdministrador;

export default function EmpresaAdministradorDetailPage() {
  const { t } = useTranslation();
  const isEditable = useSelector(isEditableSelector);
  const administrador = useSelector(administradoreSelector);
  const { formatDate, formatDateTime, formatBoolean } = useFormatter();
  const loading = useLoading(fetchAdministrador.typePrefix);
  const history = useHistory();
  const match = useRouteMatch();
  const nivel = useSelector(administradoresAlertaNivelSelector);
  const empresaId = match.params.empresaId;
  const id = match.params.id;
  const { moduloBasePath } = useModulo();
  const location = useLocation();
    const pathname = location.pathname;
    const origem = pathname.substring(pathname.indexOf("/empresas"));
    const modulo = pathname.split("/")[1];
    const [tarefasDrawerVisible, setTarefasDrawerVisible] = useState(false);

  const isNA = nivel === Alerta.Nivel.NA.id || nivel === Alerta.Nivel.inativo.id;

  const handleEdit = () => {
    history.replace(`${moduloBasePath}/empresas/${empresaId}/administradores/${id}/edit`);
  };

  const handleBack = () => {
    history.replace(`${moduloBasePath}/empresas/${empresaId}/administradores`);
  };

  const handleLogs = () => {
    openPopup(`/logs?categoria=/empresas/${empresaId}/administradores/${id}/`, `logs_/empresas/${empresaId}/administradores/${id}/`);
  };

  return (
    <Spin spinning={loading}>
      <TarefasDrawer visible={tarefasDrawerVisible} origem={origem} modulo={modulo} empresaId={empresaId}  onClose={() => setTarefasDrawerVisible(false)} />
      <ActionBar>
         <ActionButton.Tarefa disabled={isNA} onClick={() => setTarefasDrawerVisible(true)} />
        {isEditable && <ActionButton.Edit onClick={handleEdit} disabled={isNA} />}
        <ActionButton.Back onClick={handleBack} />
        <ActionButton.Logs noTitle onClick={handleLogs} />
      </ActionBar>
      <Row gutter={[16, 8]}>
        <Col flex="300px">
          <TextItem label={t('Tipo')}>{findByIdAndMap(Tipo, administrador?.tipo, (tipo) => t(tipo.label))}</TextItem>
        </Col>
        <Col flex="300px">
          <TextItem label={t('Nome')}>{administrador?.nome}</TextItem>
        </Col>
        <Col flex="200px">
          <TextItem label={t('CPF')}>{formatCpf(administrador?.cpf)}</TextItem>
        </Col>
      </Row>
       <Row gutter={[16, 8]}>
        <Col flex="400px">
          <TextItem label={t('email')}>{administrador?.email}</TextItem>
        </Col>
      </Row>
      <Row gutter={[16, 8]}>
        <Col flex="300px">
          <TextItem label={t('Data Inicial')}>{formatDate(administrador?.dataInicial)}</TextItem>
        </Col>
        <Col flex="300px">
          <TextItem label={t('Prazo Indeterminado')}>{formatBoolean(administrador?.indeterminado)}</TextItem>
        </Col>
         <Col flex="100px">
          <TextItem label={t('Cargo')}>{administrador?.cargo}</TextItem>
        </Col>
        <Col flex="200px">{administrador?.indeterminado === false && <TextItem label={t('Data Final')}>{formatDate(administrador?.dataFinal)}</TextItem>}</Col>
      </Row>
      <Row gutter={[16, 8]}>
        <Col flex="100px">
          <TextItem label={t('e-CPF')}>{formatBoolean(administrador?.eCpf)}</TextItem>
        </Col>
        <Col flex="200px">
          <TextItem label={t('Remuneração')}>{findByIdAndMap(Remuneracao, administrador?.remuneracao, (remuneracao) => t(remuneracao.label))}</TextItem>
        </Col>
        <Col flex="200px">
          <TextItem label={t('Representação')}>
            {findByIdAndMap(Representacao, administrador?.representacao, (representacao) => t(representacao.label))}
          </TextItem>
        </Col>
      </Row>
      <Row gutter={[16, 8]}>
        <Col flex="800px">
          <TextItem label={t('Poderes')}>{administrador?.poderes}</TextItem>
        </Col>
      </Row>
      <Row gutter={[16, 8]}>
        <Col flex="800px">
          <TextAnexo label={t('Anexo')} value={administrador?.anexo} />
        </Col>
      </Row>
      <Row gutter={[16, 8]}>
        <Col flex="800px">
          <TextItem label={t('Observação')}>{administrador?.obs}</TextItem>
        </Col>
      </Row>
      <Row gutter={[16, 8]}>
        <Col flex="200px">
          <TextItem label="Criado em">{formatDateTime(administrador?.createdAt)}</TextItem>
        </Col>
        <Col flex="200px">
          <TextItem label="Alterado em">{formatDateTime(administrador?.updatedAt)}</TextItem>
        </Col>
        <Col flex="200px">
          <TextItem label="Id">{empresaId}</TextItem>
        </Col>
      </Row>
    </Spin>
  );
}
